export const adminStructureDe = {
  "AdminStructure.overview": "Übersicht",
  "AdminStructure.tenants": "Mandanten und Benutzer",
  "AdminStructure.billing": "Abrechnung",
  "AdminStructure.operations": "Betrieb und Diagnose",
  "AdminStructure.settings": "Einstellungen",
  "AdminStructure.general": "Allgemein",
  "AdminStructure.jobs": "Aufträge",
  "AdminStructure.back": "zurück zu",
  "AdminStructure.payroll": "Lohn-Grundlagen",
  "AdminStructure.marketing": "KI und Medien",
  "AdminStructure.classification": "Klassifizierung",
} as const;

export const adminStructureEn = {
  "AdminStructure.overview": "Overview",
  "AdminStructure.tenants": "Tenants and users",
  "AdminStructure.billing": "Billing",
  "AdminStructure.operations": "Operations and diagnostics",
  "AdminStructure.settings": "Settings",
  "AdminStructure.general": "General",
  "AdminStructure.jobs": "Jobs",
  "AdminStructure.back": "back to",
  "AdminStructure.payroll": "Payroll reference data",
  "AdminStructure.marketing": "AI and media",
  "AdminStructure.classification": "Classification",
} as const;

export const adminStructureRu = {
  "AdminStructure.overview": "Обзор",
  "AdminStructure.tenants": "Организации и пользователи",
  "AdminStructure.billing": "Биллинг",
  "AdminStructure.operations": "Эксплуатация и диагностика",
  "AdminStructure.settings": "Настройки",
  "AdminStructure.general": "Общие",
  "AdminStructure.jobs": "Задания",
  "AdminStructure.back": "назад к",
  "AdminStructure.payroll": "Справочники расчёта зарплаты",
  "AdminStructure.marketing": "ИИ и медиа",
  "AdminStructure.classification": "Классификация",
} as const;
